export default __webpack_public_path__ + "static/media/PWK-OSCP-badge.0bef81bf.png";